// The master-user JWT is an HTTP-only cookie the app cannot see, so a stored user means signed in.
export function hasMasterSession(loginToken) {
  return Boolean(loginToken?.response?.user?._id);
}

export function withoutToken(response) {
  if (!response || typeof response !== 'object' || Array.isArray(response)) return response;
  const { token, ...rest } = response;
  return rest;
}

export function sessionKey(loginToken) {
  const response = loginToken?.response;
  if (!response?.user?._id) return null;
  return `${response.user._id}:${response.sessionId ?? ''}`;
}

export function persistedSessionKey(persistRootValue) {
  try {
    return sessionKey(JSON.parse(JSON.parse(persistRootValue).loginToken));
  } catch {
    return null;
  }
}

// The pre-auth 2FA token only lives for the current login attempt, so it never goes to localStorage.
export function toPersistedLoginState(slice) {
  if (!slice || typeof slice !== 'object') return slice;
  const { twoFactorToken, requiresTwoFactor, ...rest } = slice;
  return { ...rest, response: withoutToken(rest.response) };
}
